import { ButtonV4 } from "../common/ui";

import { type getReviewItems } from "./ordersModelV4";

// Types
type ModalOrderReviewV4Props = {
  // data
  items: ReturnType<typeof getReviewItems>;
  // callback
  onClose: () => void;
  onConfirm: () => void;
};

/** ตรวจทานก่อนส่งคำสั่ง: รายการที่ควรตรวจสอบอีกครั้ง */
const ModalOrderReviewV4 = (props: ModalOrderReviewV4Props) => {
  // Render
  return (
    <div className="hv4-modal">
      <section
        role="dialog"
        aria-modal="true"
        aria-label="ตรวจทานก่อนส่งคำสั่ง"
        className="hv4-card hv4-modal-card hv4-ord-review"
      >
        <h2 className="hv4-card-title">ตรวจทานก่อนส่งคำสั่ง</h2>
        <p className="hv4-ord-review-sub">มีรายการที่ควรตรวจสอบอีกครั้ง</p>
        <div className="hv4-ord-review-list">
          {props.items.map((item) => (
            <div key={item.text} className="hv4-ord-review-item">
              <span>{item.icon}</span>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
        <div className="hv4-ord-adr-actions">
          <ButtonV4 variant="ghost" onClick={props.onClose}>
            กลับไปแก้ไข
          </ButtonV4>
          <ButtonV4 variant="confirm" onClick={props.onConfirm}>
            ยืนยันส่งคำสั่ง
          </ButtonV4>
        </div>
      </section>
    </div>
  );
};

ModalOrderReviewV4.displayName = "ModalOrderReviewV4";

export default ModalOrderReviewV4;
